/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function(Drupal, $) {
  "use strict";

  // To understand behaviors, see https://www.drupal.org/node/2269515
  Drupal.behaviors.naic = {
    attach: function(context, settings) {
      // Execute code once the DOM is ready. $(handler) not required
      // within Drupal.behaviors.

      // Javascript function to go to a new page defined by a SELECT element. Used throughout on select menus.
      function goToPage(id) {
        var node = document.getElementById(id);
        // Check to see if valid node and if node is a SELECT form control
        if (node && node.tagName == "SELECT") {
          // Go to web page defined by the VALUE attribute of the OPTION element
          if (node.options[node.selectedIndex].value != "") {
            window.open(node.options[node.selectedIndex].value, "_blank");
            node.selectedIndex = "Select a State";
          }
        }
      }

      //build month calendar display
      var current = new Date(),
        placeholder = '<div class="calDay" data-date="">&nbsp;</div>',
        call_date_array = [],
        calYr,
        calMth,
        calDate,
        calDay,
        isLeapYear,
        days,
        months = [
          "",
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];

      var setCalDate = function(dateInfo) {
        for (var i = 0, x = 42; x > i; x--) {
          $("#calBody").append(placeholder);
        }

        calYr = dateInfo.getFullYear();

        isLeapYear = new Date(calYr, 1, 29).getMonth() == 1 ? 1 : 0;
        days = [0, 31, 28 + isLeapYear, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        calMth = dateInfo.getMonth() + 1;
        calDate = dateInfo.getDate();
        calDay = dateInfo.getDay();
        buildCal();
      };

      var buildCal = function() {
        $("#calMonth").text(months[calMth] + " " + calYr);
        var first = new Date(calYr, calMth - 1, 1);
        var first_day = first.getDay();
        var numDays = days[calMth];
        for (var x = 0; x < numDays; x++) {
          var holder = x + first_day;
          var loc = $("#calContainer")
            .find("div.calDay")
            .eq(holder);
          loc.text(x + 1);
          loc.attr("data-date", calYr + "" + calMth + "" + (x + 1));
        }
        call_date_array = [];
        $(".cal_call").each(function() {
          if ($.inArray($(this).data("date"), call_date_array) == -1) {
            call_date_array.push($(this).data("date"));
          }
        });
        for (var i = 0, y = $("div.calDay").length; i < y; i++) {
          if (
            jQuery.inArray(
              $("div.calDay")
                .eq(i)
                .data("date"),
              call_date_array
            ) !== -1
          ) {
            $("div.calDay")
              .eq(i)
              .addClass("calDay--active")
              .wrap(
                '<a href="#' +
                  $("div.calDay")
                    .eq(i)
                    .text() +
                  '"></a>'
              );
          }
          if (
            calMth == $("#calContainer").data("month") &&
            calYr == $("#calContainer").data("year") &&
            $("#calContainer")
              .find("div.calDay")
              .eq(i)
              .text() == $("#calContainer").data("day")
          ) {
            $("#calContainer")
              .find("div.calDay")
              .eq(i)
              .addClass("calDay--current");
          }
        }
      };
      //end calendar

      $(document).ready(function() {
        //mobile active
        if ($(".mobile_flyout").is(":visible")) {
          $(".right_content").attr("aria-hidden", "true");
        }

        document.querySelectorAll('.mobile_flyout').forEach((mobileFlyout) => {
          once('click_me', mobileFlyout.closest('a')).forEach((anchor) => {
            anchor.addEventListener('click', (e) => {
              const mobileFlyout = anchor.querySelector('.mobile_flyout');
              const rightContent = document.querySelector('.right_content');

              if (mobileFlyout.classList.contains('active')) {
                mobileFlyout.classList.remove('active');
                rightContent.classList.remove('active');
                rightContent.setAttribute('aria-hidden', 'true');
              } else {
                mobileFlyout.classList.add('active');
                rightContent.classList.add('active');
                rightContent.setAttribute('aria-hidden', 'false');
              }
            });

            anchor.addEventListener('keypress', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // Prevent default behavior for space or enter
                anchor.click();
              }
            });
          });
        });

        //call calendar script
        if (document.getElementById("calContainer") != "null") {
          var pathname = window.location.pathname.split("/"),
            pth_length = pathname.length,
            path_yr_mth = pathname[pth_length - 1];

          if (path_yr_mth == "naic-public-calendar") {
            setCalDate(current);
            if (calMth.toString().length < 2) {
              calMth = "0" + calMth;
            }
            window.location.replace(
              window.location.href + "/" + calYr + calMth
            );
          } else {
            var path_yr = path_yr_mth.slice(0, 4);
            var path_mth = path_yr_mth.slice(-2);
            //console.log(path_yr);
            //console.log(path_mth);

            if (
              current.getFullYear == path_yr &&
              current.getMonth == path_mth - 1
            ) {
              setCalDate(current);
            } else {
              current = current.setDate(1);
              current = new Date(current);
              current = current.setMonth(path_mth - 1);
              current = new Date(current);
              current = current.setFullYear(path_yr);
              current = new Date(current);
              setCalDate(current);
            }
          }

          $("#calPrev", context).on("click", function(event) {
            event.preventDefault();
            var href =
              "http://" +
              window.location.host +
              window.location.pathname.replace(path_yr_mth, "");
            var yr_mth = Number(path_yr_mth);
            if (path_yr_mth.slice(-2) == "01") {
              window.location.replace(href + (yr_mth - 89));
            } else {
              window.location.replace(href + (yr_mth - 1));
            }
          });
          $("#calNext", context).on("click", function(event) {
            event.preventDefault();
            var href =
              "http://" +
              window.location.host +
              window.location.pathname.replace(path_yr_mth, "");
            var yr_mth = Number(path_yr_mth);
            if (path_yr_mth.slice(-2) == "12") {
              window.location.replace(href + (yr_mth + 89));
            } else {
              window.location.replace(href + (yr_mth + 1));
            }
          });
        }

        //'go' select press call
        $("#goto_form", context).on("click keypress", ".btn", function(e) {
          goToPage("select2");
        });

        //setup left-right content in naic-generic paragraphs
        if ($(".paragraph").length > 0) {
          $(".paragraph--type--naic-right-column")
            .closest("div")
            .remove()
            .appendTo(".naic_gen__right_content");

          $(".paragraph--type--naic-section")
            .closest("div")
            .remove()
            .appendTo(".naic_gen__left_content");
          $(".paragraph--type--naic-50")
            .closest("div")
            .remove()
            .appendTo(".naic_gen__50_container");
          if ($(".paragraph--type--naic-50").length > 0) {
            $(".naic_gen__title").hide();
          }
          if ($(".paragraph--type--naic-left-column-template").length > 0) {
            $(".naic_gen__title").hide();
          }
          if ($(".paragraph--type--naic-section").length > 0) {
            $(".naic_gen__title").hide();
          }
          if ($(".paragraph--type--right-column").length > 0) {
            $(".naic_gen__title").hide();
          }
        }
      });

      $(window).on("load", function() {
        // Execute code once the window is fully loaded.

        //change workflow block depending on realm
        if ($(".gotoworkflow").length > 0) {
          var origin = window.location.origin;
          //console.log(origin);
          if (origin === "https://content.naic.org") {
            //console.log("good");
          } else {
            $(".gotoworkflow").css({
              "background-color": "red",
              color: "white",
              "text-decoration": "underline"
            });
            $(".gotoworkflow a").text("NOT IN LIVE");
          }
        }

        //tab scripts
        $(".webpost_tabs__tab", context).on("click keypress", function(e) {
          e.preventDefault();
          var tab = $(this).attr("id");
          $(".webpost_tabs__tab--selected", context)
            .attr("aria-selected", "false")
            .removeClass("webpost_tabs__tab--selected");
          $(".webpost_tabs__content--selected", context)
            .attr("aria-hidden", "true")
            .removeClass("webpost_tabs__content--selected");
          $(this)
            .addClass("webpost_tabs__tab--selected")
            .attr("aria-selected", "true");
          $('.webpost_tabs__content[aria-labelledby="' + tab + '"]')
            .addClass("webpost_tabs__content--selected")
            .attr("aria-hidden", "false");
        });

        if ($(".webpost_tabs__tab").length > 0 && location.search) {
          var tab = location.search.replace("?", "");
          $(".webpost_tabs__tab--selected", context)
            .attr("aria-selected", "false")
            .removeClass("webpost_tabs__tab--selected");
          $(".webpost_tabs__content--selected", context)
            .attr("aria-hidden", "true")
            .removeClass("webpost_tabs__content--selected");
          $("#" + tab)
            .addClass("webpost_tabs__tab--selected")
            .attr("aria-selected", "true");
          $('.webpost_tabs__content[aria-labelledby="' + tab + '"]')
            .addClass("webpost_tabs__content--selected")
            .attr("aria-hidden", "false");
        }

        $(".webpost_tabs2__tab", context).on("click keypress", function(e) {
          e.preventDefault();
          var tab = $(this).attr("id");
          $(".webpost_tabs2__tab--selected", context)
            .attr("aria-selected", "false")
            .removeClass("webpost_tabs2__tab--selected");
          $(".webpost_tabs2__content--selected", context)
            .attr("aria-hidden", "true")
            .removeClass("webpost_tabs2__content--selected");
          $(this)
            .addClass("webpost_tabs2__tab--selected")
            .attr("aria-selected", "true");
          $('.webpost_tabs2__content[aria-labelledby="' + tab + '"]')
            .addClass("webpost_tabs2__content--selected")
            .attr("aria-hidden", "false");
        });

        //member bio SELECT 'go' calls
        $(".member_bio__select_state .goToPage", context).on(
          "click keypress",
          function(e) {
            e.preventDefault();
            if (e.which !== 13 && e.type !== "click") {
              return;
            }
            goToPage("select1");
          }
        );

        //image lazy-loader for article treatments
        var lazy_loader = function(art) {
          var img_holder = $("." + art + "--active").find("img");
          var img_src = img_holder.data("src");
          img_holder.attr("src", img_src);
        };

        //javascript article transition for homepage
        var c1 = "naic_homepage__news_art";
        var c2 = "naic_homepage__news_tab";
        var node_position = 0;
        var node_length = 0;
        var node_array = [];

        if ($("." + c1, context).length > 0) {
          $("." + c1 + ":eq(0)", context)
            .addClass(c1 + "--active")
            .attr("aria-hidden", "false");
          $("." + c2 + ":eq(0)", context).addClass(c2 + "--active");

          lazy_loader(c1);

          $("." + c1).each(function() {
            node_array.push($(this).data("node"));
            node_length++;
          });
          //console.log(node_array);
          //console.log(node_length);
        }

        var make_active = function(node) {
          $("." + c1, context)
            .removeClass(c1 + "--active")
            .attr("aria-hidden", "true");
          $("." + c2, context).removeClass(c2 + "--active");

          $("." + c1 + "[data-node='" + node + "']", context)
            .addClass(c1 + "--active")
            .attr("aria-hidden", "false");
          $("." + c2 + "[data-node='" + node + "']", context).addClass(
            c2 + "--active"
          );

          lazy_loader(c1);
        };

        $("." + c2, context).on("click", function(e) {
          e.preventDefault();
          var node = $(this).data("node");
          make_active(node);
          node_position = node_array.indexOf(node);
        });

        $("." + c2 + " a", context).on("click keypress", function(e) {
          if (e.which === 13) {
            e.preventDefault();
            var node = $(this)
              .find("." + c2)
              .data("node");
            make_active(node);
            node_position = node_array.indexOf(node);
          }
        });

        $(".naic_homepage__art_nav--left").on("click", function(e) {
          e.preventDefault();
          node_position = node_position - 1;
          //console.log(node_position);
          if (node_position >= 0) {
            make_active(node_array[node_position]);
          } else {
            node_position = node_length - 1;
            make_active(node_array[node_position]);
          }
        });

        $(".naic_homepage__art_nav--right").on("click", function(e) {
          e.preventDefault();
          node_position = node_position + 1;
          //console.log(node_position);
          if (node_position < node_length) {
            make_active(node_array[node_position]);
          } else {
            node_position = 0;
            make_active(node_array[node_position]);
          }
        });

        //javascript article transition for CIPR homepage
        var d1 = "cipr_homepage__news_art";
        var d2 = "cipr_homepage__news_tab";

        if ($("." + d1, context).length > 0) {
          $("." + d1 + ":eq(0)", context)
            .addClass(d1 + "--active")
            .attr("aria-hidden", "false");
          $("." + d2 + ":eq(0)", context).addClass(d2 + "--active");

          $("." + d1).each(function() {
            node_array.push($(this).data("node"));
            node_length++;
          });

          lazy_loader(d1);
        }

        var make_active_cipr = function(node) {
          $("." + d1, context)
            .removeClass(d1 + "--active")
            .attr("aria-hidden", "true");
          $("." + d2, context).removeClass(d2 + "--active");

          $("." + d1 + "[data-node='" + node + "']", context)
            .addClass(d1 + "--active")
            .attr("aria-hidden", "false");
          $("." + d2 + "[data-node='" + node + "']", context).addClass(
            d2 + "--active"
          );

          lazy_loader(d1);
        };

        $("." + d2, context).on("click", function(e) {
          e.preventDefault();
          clearTimeout(int);
          var node = $(this).data("node");
          make_active_cipr(node);
          node_position = node_array.indexOf(node);
        });

        $("." + d2 + " a", context).on("click keypress", function(e) {
          if (e.which === 13) {
            e.preventDefault();
            var node = $(this)
              .find("." + d2)
              .data("node");
            make_active(node);
            node_position = node_array.indexOf(node);
          }
        });

        $(".cipr_homepage__art_nav--left").on("click", function(e) {
          e.preventDefault();
          clearTimeout(int);
          node_position = node_position - 1;
          //console.log(node_position);
          if (node_position >= 0) {
            make_active_cipr(node_array[node_position]);
          } else {
            node_position = node_length - 1;
            make_active_cipr(node_array[node_position]);
          }
        });

        $(".cipr_homepage__art_nav--right").on("click", function(e) {
          e.preventDefault();
          clearTimeout(int);
          node_position = node_position + 1;
          //console.log(node_position);
          if (node_position < node_length) {
            make_active_cipr(node_array[node_position]);
          } else {
            node_position = 0;
            make_active_cipr(node_array[node_position]);
          }
        });

        var timeoutFunction = function() {
          node_position = node_position + 1;
          //console.log(node_position);
          if (node_position < node_length) {
            make_active_cipr(node_array[node_position]);
          } else {
            node_position = 0;
            make_active_cipr(node_array[node_position]);
          }
        };

        var int = self.setInterval(timeoutFunction, 22000);
        //end cipr homepage

        //cmte-list expand / hide
        once('click_me', document.querySelectorAll('.cmte-list__list li:first-child')).forEach((element) => {
          element.addEventListener('click', function (e) {
            if (this.classList.contains('active')) {
              this.classList.remove('active');
              Array.from(this.parentNode.children).forEach((sibling) => {
                if (sibling !== this) {
                  sibling.classList.remove('active');
                }
              });
            } else {
              this.classList.add('active');
              Array.from(this.parentNode.children).forEach((sibling) => {
                if (sibling !== this) {
                  sibling.classList.add('active');
                }
              });
            }
          });
        });

        //Committee Menu ADA Override
        if (
          $(".committee").length > 0 &&
          $(".cmte-list__list li:first-child a")
            .text()
            .trim() ==
            $("title")
              .text()
              .trim()
        ) {
          $(".cmte-list__list li:first-child")
            .find("a")
            .attr("href", "#");
          $(".cmte-list__list li:first-child a").on("click keypress", function(
            e
          ) {
            e.preventDefault();
            $(".spinner-modal").addClass("finish");
          });
        }

        //open iframe video for colorbox gallery
        if ($(".colorbox_youtube").length >= 1) {
          $(".colorbox_youtube").colorbox({
            iframe: true,
            innerWidth: 640,
            innerHeight: 390
          });
        }

        //show first of daily news dates
        var dn_dates = [];
        var dn_once = "n";
        if ($(".dn_list__date").length >= 1 && dn_once === "n") {
          dn_once = "y";
          for (var i = 0, x = $(".dn_list__date").length; i < x; i++) {
            var dn_date_item = $(".dn_list__date")
              .eq(i)
              .data("date");
            if (dn_dates.indexOf(dn_date_item) > -1) {
              //console.log("already listed");
            } else {
              dn_dates.push(dn_date_item);
              $(".dn_list__date")
                .eq(i)
                .addClass("active");
            }
          }
        }

        //standard showhide
        //cmte-list expand / hide
        once("click_me", ".showhide", context).forEach((element) => {
          element.addEventListener("click", (e) => {
            const $element = $(element);

            if ($element.hasClass("active")) {
              $element.siblings().removeClass("active");
              $element.removeClass("active");
            } else {
              $element.addClass("active");
              $element.siblings().addClass("active");
            }
          });
        });

        //printing sortable agenda
        $('#print').on('click keypress', function(e){
          e.preventDefault();
          window.print();
        });

      });

      $(window).on("resize", function() {
        // Execute code when the window is resized.
      });

      $(window).on("scroll", function() {
        // Execute code when the window scrolls.
      });
    }
  };
})(Drupal, jQuery);
